export const USER_TYPE_REP = 'rep';
export const USER_TYPE_ADMIN = 'admin';
export const USER_TYPE_RETAILER = 'retailer';
export const USER_TYPE_PRE_LOGIN = 'pre_login';
